import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Page, Banner } from '@shopify/polaris';
import FilterTableProvider from '@container/FilterTableProvider';

import { saleReportColumns } from 'utils/recordHelpers'

const propTypes = {
  records: PropTypes.array.isRequired,
  isAdmin: PropTypes.bool,
  filterURL: PropTypes.string.isRequired,
};

const SaleReportIndex = (props) => {
  const { sellers, totalPages, records } = props;

  // const tabs = [
    // { id: 'by-transfers', content: 'Agrupados por Entrega APU', accessibilityLabel: 'Entrega APU', panelID: 'by-transfers' },
    // { id: 'by-blablabla', content: 'Legacy', accessibilityLabel: 'sa', panelID: 'by-blablabla' },
  // ];
  
  return (
    <FilterTableProvider
      pageProps={{
        title: I18n.t("activerecord.models.sale_report.other"),
      }}
      users={ sellers }

      filterByCreation={false}
      paramsName="filters"
      searchName=""
      filterURL={ props.filterURL }
      itemURL="/sale_reports"
  
      initialFilters={{
        user_id: (sellers.length > 0) && sellers[0].value,
        start_date: new Date(),
        end_date: new Date(),
      }}
      initialRecords={ records }
      columnsInfo={ saleReportColumns }

      initialTotalPages={ totalPages }
      legacy={ false }
    >
    </FilterTableProvider>
  );
}

SaleReportIndex.propTypes = propTypes;


export default SaleReportIndex;
